module.exports = __webpack_public_path__ + "static/media/Jetpak.90ffc94e.svg";